import { useState, useEffect } from 'react';
import axios from 'axios';
import { getAyane, getRuthu, getMaseTamil, getPaksham, getThithyam, getThithyam2, getVaasaram, getNakshatraYukthayaam, getNakshatraYukthayaam2, getYogam, getYogam2, getKaranam, getKaranam2 } from '@/panchangam/services/panchangam-utils';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const GenSankalpamPage = () => {
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [pd, setPd] = useState(null);
  
  useEffect(() => {
    axios.get('/data/panchangam_data-2025-to-2028.json').then(r => {
      const d = new Date(date);
      const k = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
      setPd(r.data.find(x => x.EnglishDate === k));
    }).catch(() => {});
  }, [date]);

  const renderAudio = (src, label) => (
    <div style={{marginBottom:'15px', background:'#e8f5e9', padding:'10px', borderRadius:'8px', border:'1px solid #c8e6c9'}}>
      <div style={{fontSize:'0.8rem', fontWeight:'bold', color:T.greenDk, marginBottom:'6px'}}>{label}</div>
      <audio controls style={{width:'100%', height:'35px'}}>
        <source src={src} type="audio/mpeg" />
      </audio>
    </div>
  );

  return (
    <div style={{ background: T.bg, minHeight: '100vh', padding: '10px', fontFamily:'sans-serif' }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>பொது ஸங்கல்பம்</h1>
      </div>

      <div style={{background:'#fff', borderRadius:'8px', padding:'15px', border:'1px solid '+T.border, marginBottom:'15px'}}>
        <h2 style={{fontSize:'1rem', color:T.greenDk, marginTop:0, borderBottom:'1px solid orange', paddingBottom:'5px'}}>ஆசமனம்</h2>
        <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'10px', lineHeight:'1.5'}}>
          ஆசமனம், ப்ராணாயாமம் அடிக்கடி செய்யவேண்டியிருக்கும், எனவே, இதை நன்றாகத் தெரிந்து வைத்துக்கொண்டு கர்மாவைச் செய்தால் விரைவாகவும், சிறப்பாகவும் செய்யலாம்.
        </div>
        
        {renderAudio('https://www.brahminsnet.com/upakarma/audio/achamanam.mp3', 'Achamanam - Audio')}
        
        <div style={{fontSize:'0.85rem', color:T.maroon, marginBottom:'10px', lineHeight:'1.5'}}>
          ஒரு நாளில், ஒரு கர்மாவின் ஆரம்பத்திலும், முடிவிலும் இரண்டு முறை ஆசமனம் செய்யவேண்டும். இடையிடையே ஒவ்வொரு முறை செய்தால் போறும்.
        </div>

        <div style={{background:T.cream, padding:'10px', borderRadius:'6px', border:'1px solid #ccc', fontSize:'0.9rem', lineHeight:'1.8'}}>
          ओं अच्युताय नम:। ओं अनन्ताय नम:। <br/>
          ओं गोविन्दााय नम:।<br/><br/>
          <table style={{width:'100%'}}>
            <tbody>
              <tr><td>ओं केशवाय नम:।</td><td>नारायणाय नम:।</td></tr>
              <tr><td>माधवाय नम:।</td><td>गोविन्दाय नम:।</td></tr>
              <tr><td>विष्णवे नम:।</td><td>मधुसूदनाय नम:।</td></tr>
              <tr><td>त्रिविक्रमाय नम:।</td><td>वामनाय नम:।</td></tr>
              <tr><td>श्रीधराय नम:।</td><td>हृषीकेशाय नम:।</td></tr>
              <tr><td>पद्मनाभाय नम:।</td><td>दामोदराय नम:।</td></tr>
            </tbody>
          </table>
        </div>
        
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0'}}>
          மணையில் இரு தர்பங்களை ஆசனமாகப் போட்டுக்கொண்டு, அதன்மேல் கிழக்கு நோக்கி அமரவும்.
        </div>
        <hr style={{borderColor:'orange', opacity:0.3}}/>
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0'}}>
          இரு தர்பங்களாலான பவித்திரத்தை, வலது மோதிர விரலில் அணிந்து, அதனுடன் இரு தர்பங்களைச் சேர்த்து இடுக்கிக்கொள்ளவும்.
        </div>
      </div>

      <div style={{background:'#fff', borderRadius:'8px', padding:'15px', border:'1px solid '+T.border, marginBottom:'15px'}}>
        <h2 style={{fontSize:'1rem', color:T.greenDk, marginTop:0, borderBottom:'1px solid orange', paddingBottom:'5px'}}>ப்ராணாயாமம்</h2>
        
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0'}}>
          வலது மூக்குத் துவாரத்தை, வலது கட்டை விரலால் அழுத்தி அடைக்கவும்.
        </div>
        <hr style={{borderColor:'orange', opacity:0.3}}/>
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0', lineHeight:'1.5'}}>
          வாயை நன்கு மூடி, சுட்டு விரல், நடு விரல்களை உள்ளே மடித்து, இட மூக்குத் துவாரம் வழியாக, வெளிக்காற்றை, முடிந்தவரை உள்ளிழுத்து நிறுத்தி, மோதிர, சுண்டு விரல்களால், இடமூக்குத் துவாரத்தையும் நன்கு அடைத்து ப்ராணாயாம மந்திரத்தை 3 முறை சொல்லவும்.
        </div>

        {renderAudio('https://www.brahminsnet.com/upakarma/audio/mp4/03-pranayamam1.mp4', 'Pranayamam - Audio')}
        
        <div style={{background:T.cream, padding:'10px', borderRadius:'6px', border:'1px solid #ccc', fontSize:'0.9rem', lineHeight:'1.8'}}>
          ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ: ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம்,
          தத்ஸவிதுர்வரேண்யம் பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத் ஓமாப: ஜ்யோதீரஸ:
          அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.<br/><br/>
          ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
          ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
        </div>
      </div>

      <div style={{background:'#fff', borderRadius:'8px', padding:'15px', border:'1px solid '+T.border, marginBottom:'15px'}}>
        <h2 style={{fontSize:'1rem', color:T.greenDk, marginTop:0, borderBottom:'1px solid orange', paddingBottom:'5px'}}>வடகலை ஆரம்பம்</h2>
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0'}}>கையைக் கூப்பிக்கொண்டு மந்திரங்களைச் சொல்ல ஆரம்பிக்கவும்.</div>
        
        {renderAudio('https://www.brahminsnet.com/upakarma/audio/mp4/04-vkbegining.mp4', 'VK-Begin - Audio')}
        
        <div style={{background:T.cream, padding:'10px', borderRadius:'6px', border:'1px solid #ccc', fontSize:'0.9rem', lineHeight:'1.8'}}>
          ஓம் அஸ்மத் குருப்யோ நம: ஸ்ரீமான் வேங்கட நாதார்ய: கவிதார்கிக கேசரி வேதாந்தாசார்ய வர்யோமே ஸந்நிதத்தாம் ஸதாஹ்ருதி குருப்ய: தத்குருப்யஸ்ச்ச நமோவாகம் அதீமஹே வ்ருணீமஹேச தத்ராத்யௌ தம்பதி ஜகதாம்பதி ஸ்வசேஷ பூதேநமயா ஸ்வீயை: ஸர்வபரிச்சதை: விதாதும் ப்ரீதமாத்மாநம் தேவ: ப்ரக்ரமதே ஸ்வயம்.
        </div>
      </div>

      <div style={{background:'#fff', borderRadius:'8px', padding:'15px', border:'1px solid '+T.border, marginBottom:'15px'}}>
        <h2 style={{fontSize:'1rem', color:T.greenDk, marginTop:0, borderBottom:'1px solid orange', paddingBottom:'5px'}}>தென்கலை, ஸ்மார்த்தா ஆரம்பம் (வடகலை தொடர்ச்சி)</h2>
        
        {renderAudio('https://www.brahminsnet.com/upakarma/audio/mp4/05-suklambara.mp4', 'Suklambaradharam - Audio')}
        
        <div style={{background:T.cream, padding:'10px', borderRadius:'6px', border:'1px solid #ccc', fontSize:'0.9rem', lineHeight:'1.8'}}>
          சுக்லாம்பரதரம் விஷ்ணும் சசிவர்ணம் சதுர்புஜம் ப்ரஸன்னவதனம் த்யாயேது ஸர்வவிக்னோபசாந்தயே யஸ்யத்விரத வக்த்ராத்யா: பாரிஷத்யா: பரஸ்சதம் விக்னம் நிக்னந்தி சததம் விஷ்வக்ஸேனம் தமாச்ரயே.
        </div>
      </div>

      <div style={{background:'#fff', borderRadius:'8px', padding:'15px', border:'1px solid '+T.border, marginBottom:'15px'}}>
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0', fontWeight:'bold'}}>வலது தொடையில் இடதுகைமேல் வலது கைவைத்து...</div>
        
        <div style={{background:T.cream, padding:'10px', borderRadius:'6px', border:'1px solid #ccc', fontSize:'0.9rem', lineHeight:'1.8'}}>
          ஹரிரோம்தத்<br/>
          <span style={{color:'green', fontSize:'0.8rem'}}>(தர்பணம் முதலிய பித்ரு கர்மாக்களுக்கு இந்த இடத்தில் ப்ராசீனாவீதம் போட்டுக்கொள்ள வேண்டும். “சுப திதௌ” - என்று உள்ள இடங்களில் “புண்ய திதௌ” என மாற்றிச் சொல்லிக்கொள்ளவேண்டும்.)</span><br/><br/>
          ஸ்ரீ கோவிந்தா கோவிந்த கோவிந்தா அஸ்யஸ்ரீ பகவத: மஹாபுருஷ்ஸ்ய விஷ்ணோராஜ்ஞயா ப்ரவர்த்தமானஸ்ய ஆத்ய ப்ரஹ்மண: த்விதீயபரார்த்தே ஸ்ரீ ஸ்வேதவராஹ கல்பே வைவஸ்வத மன்வந்தரே கலியுகே ப்ரதமே பாதே
        </div>
        
        {renderAudio('https://www.brahminsnet.com/upakarma/audio/mp4/06-gensankalpam.mp4', 'HariromTat - Audio')}
        
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0'}}><b>இந்தியாவில் இருப்பவர்கள்:</b> ஜம்பூத்வீபே பாரதவர்ஷே பரதக்கண்டே</div>
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0'}}><b>வெளிநாட்டில் இருப்பவர்கள்:</b> த்வீபம் வர்ஷம் கண்டம் தெரியாதவர்கள் “விஷ்ணு” என்பதை உபயோகித்துக்கொள்ளலாம். அதாவது “விஷ்ணு த்வீபே” “விஷ்ணு வர்ஷே”, “விஷ்ணு கண்டே” என்று சொல்லலாம்</div>
        <div style={{fontSize:'0.85rem', color:T.maroon, margin:'10px 0'}}><b>எல்லோரும் சொல்லவும்:</b> சகாப்தே மேரோ: தக்ஷிணே பார்சவே அஸ்மின் வர்தமானானாம் வ்யவஹாரிகானாம் ப்ரபவாதீநாம் ஷஷ்டி ஸம்வத்ஸராணாம் மத்யே .....</div>
      </div>

      {/* Dynamic Date Section */}
      <div style={{background:'#090b72', color:'white', borderRadius:'8px', padding:'15px', marginBottom:'15px', textAlign:'center'}}>
        <h2 style={{fontSize:'1.1rem', margin:0}}>இன்றைய ஸங்கல்பம்</h2>
        <input type="date" value={date} onChange={e => setDate(e.target.value)}
          style={{ padding: '8px', borderRadius: '6px', border: '1px solid #ccc', margin: '15px 0', fontSize:'16px' }} />
        
        {pd && (
          <div style={{background:'#fffef0', color:'#333', padding:'15px', borderRadius:'8px', textAlign:'left', lineHeight:'1.8'}}>
             {pd.YearNameInTamil} நாம ஸம்வத்ஸரே - {getAyane(pd.TamilMonthNumber)} - {getRuthu(pd.TamilMonthNumber)}-ருதௌ - {getMaseTamil(pd.TamilMonthNumber)} மாஸே - {getPaksham(pd.PakshamNameInTamil, pd.Paksham)}பக்ஷே -
            {getThithyam(pd.ThithiNumber)}-({pd.ThithiDuration}) சுப திதௌ -
            <span style={{backgroundColor: '#F2E100'}}>(அடுத்த திதி: {getThithyam(pd.Thithi2Number)} )</span>
            - வாஸர: {getVaasaram(pd.EnglishDay)} வாஸர யுக்தாயாம் - {getNakshatraYukthayaam(pd.NakshatraNumber)} ({pd.NakshatraDuration}) நக்ஷத்ர யுக்தாயம்
            <span style={{backgroundColor: '#F2E100'}}>(அடுத்த நக்ஷத்ரம்: {getNakshatraYukthayaam(pd.Nakshatra2Number)} )</span>
            - {pd.YogaNameInTamil}({pd.YogaDuration}) யோக யுக்தாயாம்
            - {pd.KaranamNameInTamil}({pd.KaranaDuration}) கரண யுக்தாயாம்
            ஏவங்குண விசேஷண விசிஷ்டாயாம் அஸ்யாம் {getThithyam(pd.ThithiNumber)} சுப திதௌ .......
          </div>
        )}
      </div>

      <div style={{background:'#fff', borderRadius:'8px', padding:'15px', border:'1px solid '+T.border}}>
        <div style={{fontSize:'0.85rem', color:T.maroon, lineHeight:'1.5'}}>
          <b>குறிப்பு:-</b> இதுபோல் ஸ்ரீ-ம் என்று உள்ள இடங்களிலெல்லாம் ...<br/>
          வடகலையார் - ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந் நாராயண ப்ரீத்யர்த்தம் என்றும்,<br/>
          தென்கலையார் - ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீபகவத் கைங்கர்யம் என்றும்,<br/>
          ஸ்மார்த்தா - மமோ பார்த்த சமஸ்த துரிதக்ஷய த்வாரா ஸ்ரீ பரமேஸ்வர ப்ரீத்யர்த்தம் என்றும் சொல்லிக் கொள்ளவும்)<br/>
          இதன் பிறகு அந்தந்த கர்மாவுக்கான விசேஷ ஸங்கல்பத்தைச் சொல்லிக்கொள்ளவேண்டும்.
        </div>
      </div>
    </div>
  );
};
export default GenSankalpamPage;